import React, { Component } from 'react'
import {
    Container
} from 'reactstrap'
import Navegacion from '../navbar'
import './mainAdmin.css'
import Analytics from '../analytics'

export default class Main extends Component {
    constructor(props) {
        super(props)

        this.state = {
            usuario: true,
        }
    }


    render() {
        return (
            <Container className="containerAdmin">
                <Navegacion showPrincipal={this.props.showPrincipal} setPage={this.setPage} modalLogin={this.props.loginToggle} user={this.props.user} logOut={this.props.logOut} />
                <Analytics/>
            </Container>
        )
    }

}